import { Formik } from 'formik';
import { useTranslation } from 'react-i18next';
import { Box } from 'reflexbox';

import { Paragraph, Subheading, tokens } from '@treams/treams-ui';

import BareLayout from '../../../../../../src/packages/kakapo-ui-application/layouts/BareLayout';
import PublicForm from '../../components/authentication/PublicForm';

export default function ForgotPassword() {
	const { t } = useTranslation();

	return (
		<BareLayout>
			<Formik initialValues={{}} onSubmit={() => {}}>
				{() => (
					<PublicForm>
						<Box textAlign="center">
							<Subheading mb={`${tokens.gap.group}px`}>
								{t('common.checkInbox.success.subtitle')}
							</Subheading>
							<Paragraph mb={4}>{t('common.checkInbox.success.title')}</Paragraph>
							<Paragraph>{t('common.checkInbox.success.message')}</Paragraph>
						</Box>
					</PublicForm>
				)}
			</Formik>
		</BareLayout>
	);
}
